import React from 'react'
import { Box } from '@mui/material'
import AppLogo from '@assets/AppLogo.png'

interface SidebarHeaderProps {
  isDarkMode?: boolean
}

const SidebarHeader: React.FC<SidebarHeaderProps> = ({ isDarkMode = false }) => {
  return (
    <Box
      sx={{
        borderBottom: `1px solid ${isDarkMode ? '#2d4a7c' : '#e0e0e0'}`,
        display: 'flex',
        justifyContent: 'flex-end',
        marginRight: '5px',
        transition: 'border-color 0.3s ease',
      }}
    >
      <img src={AppLogo} alt="Logo" style={{ width: 'clamp(45px, 6vh, 70px)', height: 'auto' }} />
    </Box>
  )
}

export default SidebarHeader
